import { useEffect, useState } from "react";
const { normalizeSalesforceValue } = require("../shared/salesforceDiploma");
const { getVisibleSousCritereEntries, hasRequiredAlternanceAcceptance } = require("../shared/progress");

const SALESFORCE_FIELD_ALIASES_BY_QUESTION_ID = {
  153: ["00NaT000000KOcT"],
  154: ["00NaT000000KOXd"],
  217: ["00N2o000006WwJ3"]
};

function escapeAttributeValue(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function salesforceFieldIdsForQuestion(question) {
  const ids = [];
  if (question?.idForm) {
    ids.push(String(question.idForm));
  }
  const aliases = SALESFORCE_FIELD_ALIASES_BY_QUESTION_ID[Number(question?.id)] || [];
  aliases.forEach((idForm) => {
    if (idForm && !ids.includes(idForm)) {
      ids.push(idForm);
    }
  });
  return ids;
}

function buildSalesforceAliasInputs(question, value) {
  const primaryId = question?.idForm ? String(question.idForm) : "";
  return salesforceFieldIdsForQuestion(question)
    .filter((idForm) => idForm && idForm !== primaryId)
    .map((idForm) => `<input style="display: none" id="${idForm}" name="${idForm}" type="text" value="${escapeAttributeValue(value)}" />`)
    .join("");
}

export default function Navbar2({ getBtnRetourActif, getBtnSoumissionActif, getBtnSoumissionDossier, getMainActifNum, setMainActifNum, getNumberFiliereActif, setNumberCritereActif, setNumberSousCritereActif, data, isDisabled, mail, candidature, niveau, setsendToCrmValue, sendDataToServer, Lang, token, sendToCrmValueOrigin, checkPaymentExists, triggerSave, recordNav }) {


  const [getBtnOui, setBtnOui] = useState("Oui");
  const [getBtnNon, setBtnNon] = useState("Non");
  const [getEtesVousSur, setEtesVousSur] = useState("Êtes-vous sûr de vouloir envoyer votre dossier? Vous ne pourrez plus faire de modifications ultérieurement.");


  useEffect(() => {
    setBtnOui(Lang === "en" ? "Yes" : "Oui");
    setBtnNon(Lang === "en" ? "No" : "Non");
    // Les candidatures n'ont plus d'étape de paiement : l'avertissement de non-retour
    // est renforcé puisque ce clic est la dernière barrière avant l'envoi.
    if (data?.configuration === 'Candidature') {
      setEtesVousSur(Lang === "en" ? "Are you sure you want to submit your application? This is final: you will not be able to go back or make any changes. If you have the slightest doubt, click \"No\" to review all your information and documents one last time." : "Êtes-vous sûr de vouloir envoyer votre dossier ? Cet envoi est définitif : vous ne pourrez plus revenir en arrière ni modifier quoi que ce soit. Si vous avez le moindre doute, cliquez sur « Non » pour relire une dernière fois l'ensemble de vos informations et de vos documents.");
    } else {
      setEtesVousSur(Lang === "en" ? "Are you sure you want to submit your application? You will not be able to make any changes later." : "Êtes-vous sûr de vouloir envoyer votre dossier? Vous ne pourrez plus faire de modifications ultérieurement.");
    }

  }, [Lang, data?.configuration]);

  /* ---  SOUMISSION D'UN DOSSIER --- */

  //Empêche getMainActifNum < 0
  const handleClickDecreGetMain = () => {
    triggerSave(); // SAVE ON BACK
    if (getMainActifNum === 4) {
      if (recordNav) {
        recordNav();
      }
      setMainActifNum(1);
    } else if (getMainActifNum !== 0) {
      if (recordNav) {
        recordNav();
      }
      setMainActifNum(getMainActifNum - 1);
    }
  }

  async function nextEtape() {
    if (data?.configuration === 'Echange') { triggerSave(); return; }
    if (getMainActifNum >= 2 && !hasRequiredAlternanceAcceptance(data?.data?.[getNumberFiliereActif])) {
      return;
    }
    triggerSave(); // SAVE ON NEXT
    if (getMainActifNum === 1) {
      if (recordNav) {
        recordNav();
      }
      // Les candidatures n'ont plus d'étape « Validation du dossier » (critère 50) :
      // on passe directement à l'écran de confirmation avant envoi.
      if (data?.configuration === 'Candidature') {
        setMainActifNum(3);
        await generatesendToCrmValue();
        return;
      }
      setMainActifNum(2);
      setNumberCritereActif(data.data[getNumberFiliereActif].criteres.length - 1);
      setNumberSousCritereActif(0);
    } else if (getMainActifNum === 2) {
      if (recordNav) {
        recordNav();
      }
      setMainActifNum(3);
      await generatesendToCrmValue();
    } else if (getMainActifNum === 3) {
      if (recordNav) {
        recordNav();
      }
      setMainActifNum(4);
      if (Array.isArray(data?.data)) {
        data.data.forEach((entry, index) => {
          entry.soumis = index === getNumberFiliereActif;
        });
      }
      //console.log(data.data[0].soumis);
      sendDataToServer(data, getMainActifNum);
    } else if (getMainActifNum === 4) {
      if (Array.isArray(data?.data) && data.data[getNumberFiliereActif]) {
        data.data[getNumberFiliereActif].soumis = false;
      }
    }
  }

  useEffect(() => {
    const btnNon = document.getElementById("btnNon");
    const btnOui = document.getElementById("btnOui");

    //console.log("BTNOUI")
    if (btnNon) {
      btnNon.addEventListener("click", handleClickDecreGetMain);
    }

    if (btnOui) {
      btnOui.addEventListener("click", nextEtape);
    }

    // Nettoyage au démontage
    return () => {
      if (btnNon) {
        btnNon.removeEventListener("click", handleClickDecreGetMain);
      }
      if (btnOui) {
        btnOui.removeEventListener("click", nextEtape);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendToCrmValueOrigin]);

  async function fetchPaymentDate() {
    if (!token) {
      return "";
    }
    try {
      const response = await fetch("/backend/payment-info", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token })
      });
      if (!response.ok) {
        return "";
      }
      const payload = await response.json();
      return payload.date || "";
    } catch (error) {
      return "";
    }
  }

  async function generatesendToCrmValue() {
    if (data?.configuration === 'Echange') return;
    const selectedCourse = Array.isArray(data?.data) ? data.data[getNumberFiliereActif] : null;
    const salesforceFiliere = selectedCourse?.nom || "";
    const newNiveau = selectedCourse?.niveau || niveau || "";
    const paymentDate = await fetchPaymentDate();

    let sendToCrmValue = `
            <META HTTP-EQUIV="Content-type" CONTENT="text/html; charset=UTF-8">
        
            <!--  ----------------------------------------------------------------------  -->
            <!--  REMARQUE : Ajoutez l'élément suivant <FORM> à votre page.               -->
            <!--  ----------------------------------------------------------------------  -->
        
            <form id='envoyeCRM' action="https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8&orgId=00D2o000000soCu" method="POST">
        
            <input type=hidden name="orgid" value="00D2o000000soCu">
    
            <input style="display: none" id="00NaT000000Udn7" name="00NaT000000Udn7" value="true">
    
            <input id="URL" type="hidden" name="retURL" value="https://inscriptions.ices.fr/?tkn=` + token + `">

            <input style="display: none" id="email" name="email"  type="text" value="`+ mail + `"/>
            <input style="display: none" id="00NaT000000Zdkr" name="00NaT000000Zdkr" type="text" value="`+ candidature + `"/>
    
            `;

    if (newNiveau) {
      sendToCrmValue += `<input style="display: none" id="00N2o000006Wbl6" name="00N2o000006Wbl6" type="text" value="${newNiveau}"/>`;
    }
    if (salesforceFiliere) {
      sendToCrmValue += `<input style="display: none" id="00N2o000006WblL" name="00N2o000006WblL" type="text" value="${salesforceFiliere}"/>`;
    }

    if (paymentDate) {
      sendToCrmValue += `<input style="display: none" id="00NaT000002pk65" name="00NaT000002pk65" type="text" value="${paymentDate}"/>`;
    }
    try {
      const coursesToSubmit = selectedCourse ? [selectedCourse] : [];
      coursesToSubmit.forEach(course => {
        getVisibleSousCritereEntries(course).forEach(({ sousCritere: subCriteria }) => {
            subCriteria.questions.forEach(question => {

              if (question.type === 'select' && question.visible !== false && question.value !== "" && question.idForm) { // Exclure les questions de type 'file'
                const selectValue = normalizeSalesforceValue(question.idForm, question.value) || "";
                let inputTag = `<label style="display: none" for="${question.idForm}">${question.nom}</Label><select style="display: none" id="${question.idForm}" name="${question.idForm}"`;

                if (question.required) {
                  inputTag += ` required="${question.required}"`;
                }

                inputTag += ` >\n <option value="${escapeAttributeValue(selectValue)}">${escapeAttributeValue(selectValue)}</option>\n </select>`;

                sendToCrmValue += inputTag + buildSalesforceAliasInputs(question, selectValue);
              } else if (question.type === 'date' && question.visible !== false && question.value !== "" && question.idForm) {
                let inputTag = `<label style="display: none" for="${question.idForm}">${question.nom}</Label><span style="display: none" class="dateInput dateOnlyInput"><input style="display: none" id="${question.idForm}" name="${question.idForm}" size="12" type="text" value="${question.value || ''}"`;

                if (question.required) {
                  inputTag += ` required="${question.required}"`;
                }

                inputTag += ` /></span>`;
                sendToCrmValue += inputTag + buildSalesforceAliasInputs(question, question.value || '');


              } else if (question.type === 'search' && question.visible !== false && question.value !== "" && question.idForm) { // Exclure les questions de type 'file'
                let inputTag = `<label style="display: none" for="${question.idForm}">${question.nom}</Label><input style="display: none" id="${question.idForm}" name="${question.idForm}" type="${question.idForm}" value="${question.valueName || ''}"`;

                if (question.required) {
                  inputTag += ` required="${question.required}"`;
                }
                inputTag += ` />`;

                inputTag += `<label style="display: none" for="${question.idFormCode}">${question.nom}</Label><input style="display: none" id="${question.idFormCode}" name="${question.idFormCode}" type="${question.idForm}" value="${question.code_postal || ''}"`;

                if (question.required) {
                  inputTag += ` required="${question.required}"`;
                }
                inputTag += ` />`;

                sendToCrmValue += inputTag + buildSalesforceAliasInputs(question, question.valueName || '');
              } else if (question.type !== 'file' && question.visible !== false && question.value !== "" && question.idForm) { // Exclure les questions de type 'file'
                let inputTag = `<label style="display: none" for="${question.idForm}">${question.nom}</Label><input style="display: none" id="${question.idForm}" name="${question.idForm}" type="${question.idForm}" value="${question.value || ''}"`;

                if (question.required) {
                  inputTag += ` required="${question.required}"`;
                }

                inputTag += ` />`;

                sendToCrmValue += inputTag + buildSalesforceAliasInputs(question, question.value || '');
              }
            });
        });
      });
      sendToCrmValue += `
            <div class="containerConfirmation">
              <h1>${getEtesVousSur}</h1>
              <div class="boutonsConfirmation">
                <input type="button" id="btnNon" name="retourPaiement" value="${getBtnNon}">
                <input type="submit" id="btnOui" name="submit" value="${getBtnOui}">
              </div>
            </div>`;
    } catch { }

    setsendToCrmValue(sendToCrmValue);

  }

  /* ------------------------------------------------------------ AFFICHAGE ------------------------------------------------------------ */



  return (
    <div className="BoutonsNavMain">

      <button className={getBtnRetourActif} onClick={handleClickDecreGetMain}>
        <p>{Lang === "en" ? "Back" : "Retour"}</p>
      </button>
      <button id="BoutonSoumission" onClick={nextEtape} disabled={isDisabled || data?.configuration === 'Echange'} className={getBtnSoumissionActif}><p>{data?.configuration === 'Echange' ? (Lang === "en" ? "Submission unavailable" : "Envoi indisponible") : getBtnSoumissionDossier}</p></button>

    </div>
  );
}
